import React, { useEffect, useState } from 'react';
import { Row, Form, Col, Button, Table } from "react-bootstrap"
import { useDispatch, useSelector } from 'react-redux';
import newForm from '../../api/newForm';
import newTemplate from '../../api/newTemplate';
import validateForm from '../../api/validateForm';
import TableComponent from './Table';
import { useHistory } from "react-router-dom";
import { updateTitle } from '../../redux/updatePageHeadeSlice';
import { CREATE_NEW_FORM_HEADER } from '../../constants/headerTitles';
import { showToastAction } from '../../redux/toastSlice';

const initRow = { columnName: "", columnType: "date", columnLength: 0, page_number: 1, research_key: false, columnContent: [] }


const CreateForm = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const [data, setData] = useState({ form_name: "", description: "", form_type: "" });
    const [tableData, setTableData] = useState([initRow]);
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatch(updateTitle(CREATE_NEW_FORM_HEADER))
    }, [])

    const updateData = (key, e) => {
        setData({ ...data, [key]: e.target.value })
    }

    const commitLater = async (e) => {
        var newtabledata = [];
        for (let index = 0; index < tableData.length; index++) {
            var newindex = 'Block' + (index + 1);
            newtabledata[newindex] = tableData[index];
        }
        try {
            await newForm(selectedProject.name, data);
            await newTemplate(selectedProject.name, data.form_name, newtabledata);
            dispatch(showToastAction({ message: "Form created successfully", showToast: true, severity: "success" }))
            history.push("/projects/" + selectedProject.name);
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const submitForm = async (e) => {
        e.preventDefault();

        const totalRows = tableData.length;
        const invalidKeyRang = tableData.some(row => row.key_rang > totalRows);

        if (invalidKeyRang) {
            dispatch(showToastAction({ message: `Erreur : key_rang ne peut pas être supérieur à ${totalRows}`, showToast: true }))
            return;
        }

        var newtabledata = [];
        for (let index = 0; index < tableData.length; index++) {
            var newindex = 'Block' + (index + 1);
            newtabledata[newindex] = tableData[index];
        }
        try {
            await newForm(selectedProject.name, data);
            await newTemplate(selectedProject.name, data.form_name, newtabledata);
            await validateForm(selectedProject.name, data.form_name);
            dispatch(showToastAction({ message: "Form created successfully", showToast: true, severity: "success" }))
            history.push("/form/" + data.form_name + '/documents');
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    return (
        <div className="container recent-activities">
            <Form>
                <div className="top-form-activities">
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control type="text" placeholder="Entrez le nom du formulaire" value={data.form_name} onChange={(e) => updateData("form_name", e)} />
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Entrez la description du formulaire" value={data.description} onChange={(e) => updateData("description", e)} />
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Type formulaire</Form.Label>
                        <Form.Control as="select" value={data.form_type} onChange={(e) => updateData("form_type", e)}>
                            <option value="">Sélectionner le type</option>
                            <option value="archivage_document">Archivage de document</option>
                            <option value="insertion_donnees">Insertion de données</option>
                        </Form.Control>
                    </Form.Group>
                </div>

                <div className="table-section">
                    <TableComponent data={tableData} setData={setTableData} />
                    <div className="text-right">
                        <Button
                            className="mt-3 mr-3"
                            variant="primary"
                            onClick={commitLater}
                        >
                            Brouillon
                        </Button>
                        <Button
                            type="submit"
                            className="mt-3"
                            variant="primary"
                            onClick={submitForm}
                        >
                            Valider
                        </Button>

                    </div>
                </div>
            </Form>
        </div>
    );
}

export default CreateForm;
